import script from "./VincularFormularioModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./VincularFormularioModal.vue?vue&type=script&lang=ts&setup=true"

import "./VincularFormularioModal.vue?vue&type=style&index=0&id=336f829e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336f829e"]])

export default __exports__